import React from 'react'
import { Helmet } from 'react-helmet-async'
import IndustriesHero from '../Components/Industries/IndustriesHero'
import UnmatchedIndustryExpertise from '../Components/Industries/UnmatchedIndustryExpertise'

function NewIndustries() {
    return (
        <div>

            <Helmet>
                <title>
                    Industries We Serve | Industry-Specific Technology Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Explore Mobikode's industry-focused technology solutions designed to address unique business challenges across manufacturing, healthcare, finance, retail, logistics, energy, automotive, and other industries."
                />

                <meta
                    name="keywords"
                    content="Industries We Serve, Industry Technology Solutions, Industry Specific IT Solutions, Digital Transformation by Industry, Manufacturing Technology Solutions, Healthcare IT Solutions, Financial Services Technology, Banking Technology Solutions, Retail Technology Solutions, Logistics Technology Solutions, Automotive Technology Solutions, Energy Technology Solutions, Enterprise Technology Solutions, Industry Digital Transformation"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/industries"
                />

                <meta
                    property="og:title"
                    content="Industries We Serve | Industry-Specific Technology Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Discover Mobikode's industry expertise and technology solutions built around the specific needs of modern businesses across multiple industries."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/industries"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/Industries/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Industries We Serve | Industry-Specific Technology Solutions | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's industry-focused expertise and digital solutions designed to help organizations modernize, improve efficiency, and achieve sustainable growth."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/Industries/bg1.png"
                />
            </Helmet>

            <IndustriesHero />
            <UnmatchedIndustryExpertise />

        </div>
    )
}

export default NewIndustries